import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Client Service */
const addClient = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.client.addClient}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Client Service */
const getAllClient = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.client.getAllClient}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  /* Get Client List Service*/
const getClientList = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.client.getClientList}`,
    method: "GET",
    params: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};



  /* Update Client Service */
  const updateClient = (params) => {
    const { axiosInstance,config } = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.client.updateClient}`,
      method: "PUT",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


   /* Delete Client Service */
   const deleteClient = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.client.deleteClient}`,
      method: "DELETE",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error?.response?.data);
      });
    return response;
  };


  /* Get Client Details Service */
const getClientDetails = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.client.getClientDetails}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const updateClientDetails = (params) => {
      const dataParams ={type :'upload'}
    const { axiosInstance ,config,source} = getAxiosConfig(dataParams);
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.client.updateClientDetails}`,
      method: "POST",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

export default {
    addClient,
    getAllClient,
    getClientList,
    updateClient,
    deleteClient,
    getClientDetails,
    updateClientDetails
}